var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SearchSelect',{attrs:{"dense":"","hideDetails":"","label":"Unsortierte Tickets","items":_vm.items},on:{"change":function($event){return _vm.goToTicket($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }